<div class="auth-container">
  <div class="header">
    <div class="logo">
      <img
        src="assets/vite-marketplace-logo-dark.svg"
        [alt]="translationService.getBrandLogoText()"
        height="50px"
      />
    </div>
    <h2>{{ translationService.getSetPasswordText() }}</h2>
    <div class="password-requirements">
      {{ translationService.getPasswordInstructionsText() }}
    </div>
  </div>
  <form [formGroup]="passwordForm">
    <div class="form-groups margin-top-20">
      <div class="form-group margin-top-10">
        <mat-form-field appearance="outline">
          <mat-label>{{ translationService.getPasswordText() }}</mat-label>
          <input
            matInput
            type="password"
            name="password"
            formControlName="password"
            autocomplete="off"
          />
        </mat-form-field>
      </div>
      <div class="form-group margin-top-10">
        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getConfirmPasswordText()
          }}</mat-label>
          <input
            matInput
            type="password"
            name="confirmPassword"
            formControlName="confirmPassword"
            autocomplete="off"
          />
        </mat-form-field>
      </div>
      @if (
        !passwordForm.controls.password.valid &&
        (passwordForm.controls.password.dirty ||
          passwordForm.controls.password.touched)
      ) {
        <div class="error">
          @if (passwordForm.controls.password.errors!['invalidMsg']) {
            <div>
              {{ passwordForm.controls.password.errors!['invalidMsg'] }}
            </div>
          }
          @if (passwordForm.controls.password.errors!['minlength']) {
            <div>
              {{
                translationService.getPasswordMustBeAtleastTenCharactersLongText()
              }}
            </div>
          }
        </div>
      }
      @if (
        passwordForm.errors?.['notSame'] &&
        (passwordForm.controls.confirmPassword.dirty ||
          passwordForm.controls.confirmPassword.touched)
      ) {
        <div class="error">
          {{ translationService.getPasswordAndConfirmationMustMatchText() }}
        </div>
      }
    </div>
    <div class="actions margin-top-10">
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="onSubmit()"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getSubmitText() }}
      </button>
    </div>
  </form>
</div>
